import { costTrackerFields } from 'src/enums/cost-tracker';
import { getVisibleFields } from 'src/common/table/column-utils';

const fieldMap = Object.values(costTrackerFields);
export const getFields = (disabledFields: string[] = []) => {
  return getVisibleFields(fieldMap, disabledFields);
};
